import { Column } from './column';
import { Status } from './status';

// TODO rename to 'BoardConfiguration'
export class BoardState {

  public columns: Column[] = [];
  public boardType: string;

  constructor(columns: Column[], boardType: String) {
    this.columns = columns;
    this.boardType = boardType.toString();
  }

  /**
     * Returns an Array of all statuses of all columns
     */
  getAllStatuses(): Status[] {
    const statuses = [];
    this.columns.forEach(column => {
      column.statuses.forEach(status => {
        statuses.push(status);
      });
    });
    return statuses;
  }

  /**
     * Returns the Status-Object with <statusId> or null if not found.
     * If there are multiple Status with the same id only the last found match will be returned.
     */
  getStatus(statusId: number): Status {
    let result = null;
    this.columns.forEach(column => {
      column.statuses.forEach(status => {
        if (Number(status.id) === statusId) {
          result = status;
        }
      });
    });
    return result;
  }

  // TODO refactor/unify the way a statusobject can be retrieved
  /**
     * Returns the first Status-Object of the column with <columnName>
     * Assumes every column has at least one status.
     */
  getStatusForColumn(columnName: string): Status {
    let result = null;
    if (this.columns !== undefined) {


      this.columns.forEach(column => {
        if (column.name === columnName) {
          result = column.statuses[0];
        }
      });
    }
    return result;
  }




}
